/**
 * Action generic to all the instances.
 * @type {Object}
 */
const REDUX_ACTION = {
  LOAD: 'REDUX_LOAD',
  LOAD_SUCCESS: 'REDUX_LOAD_SUCCESS',
  LOAD_ERROR: 'REDUX_LOAD_ERROR',
  SAVE: 'REDUX_SAVE',
  SAVE_SUCCESS: 'REDUX_SAVE_SUCCESS',
  SAVE_ERROR: 'REDUX_SAVE_ERROR',
  BULK_SAVE: 'REDUX_BULK_SAVE',
  BULK_SAVE_SUCCESS: 'REDUX_BULK_SAVE_SUCCESS',
  BULK_SAVE_ERROR: 'REDUX_BULK_SAVE_ERROR',
  DELETE: 'REDUX_DELETE',
  DELETE_SUCCESS: 'REDUX_DELETE_SUCCESS',
  DELETE_ERROR: 'REDUX_DELETE_ERROR',
  DELETE_LOCALLY: 'REDUX_DELETE_LOCALLY',
  UPDATE: 'REDUX_UPDATE',
  BULK_UPDATE: 'REDUX_BULK_UPDATE',
  DISCARD: 'REDUX_DISCARD',
  VALIDATE: 'REDUX_VALIDATE',
  VALIDATION_SUCCESS: 'REDUX_VALIDATION_SUCCESS',
  VALIDATION_ERROR: 'REDUX_VALIDATION_ERROR',
  SET: 'REDUX_SET',
  RESET: 'REDUX_RESET'
}

export default REDUX_ACTION
